<onsip-personal-view
  *ngIf="teamMember | async; else notperson"
  [data]="(teamMember | async)!"
  (analyticsData)="onAnalyticsData($event)">
</onsip-personal-view>

<ng-template #notperson>
  <onsip-not-person></onsip-not-person>
</ng-template>
